import React from "react";

const AirConditioner = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M32 9H4c-1.103 0-2 .897-2 2v8.057c0 1.109.897 2.006 2 2.006h2.606l.428-2.177c.149-.766.675-1.28 1.297-1.28H27.67c.628 0 1.148.514 1.297 1.28l.423 2.177H32c1.103 0 2-.897 2-2.006V11c0-1.103-.897-2-2-2ZM7.703 13H5.566a.573.573 0 0 1-.572-.571.57.57 0 0 1 .572-.572h2.137c.751.008.753 1.132 0 1.143Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M27.846 19.108c-.046-.24-.154-.348-.189-.36H8.331c-.022.012-.13.12-.177.36-.103.466-.283 1.482-.383 1.955H28.23c-.111-.476-.277-1.486-.383-1.954Zm-16.42 3.458a.58.58 0 0 0-.61.531c-.001.017-.137 1.851-.894 3.37-.195.366.1.835.511.826.21 0 .412-.116.512-.316.857-1.72 1.006-3.716 1.012-3.8a.57.57 0 0 0-.53-.611Zm3.333.318a.572.572 0 0 0-.505.63c.099.886-.528 2.688-.778 3.308-.269.697.763 1.123 1.06.428-.072.127 1.851-4.453.223-4.366Zm10.424.212c-.066-.752-1.178-.668-1.14.08.006.085.155 2.08 1.012 3.8.34.669 1.353.159 1.023-.51-.754-1.51-.893-3.351-.895-3.37Zm-3.437.419c.07-.747-1.037-.87-1.136-.126-.148 1.33.752 3.606.854 3.86.297.694 1.33.272 1.06-.427-.25-.62-.877-2.42-.778-3.307Zm-3.715-.635a.571.571 0 0 0-.572.571v3.585a.571.571 0 1 0 1.143 0v-3.584a.572.572 0 0 0-.571-.572Z"
            fill={fill}
        />
    </svg>
);

export default AirConditioner;